import { handleError } from "@/api/handleError";
import { getUnprovisionedPayment } from "@/api/requests/payments";
import { getSubscriptionStatus } from "@/api/requests/subscription";
import router from "@/router";
import {
  useBusinessStore,
  useNumberStore,
  useUsersStore,
  useUtilsStore,
} from "@/stores";
import { getPermissions, handleFetchUserDetails } from "./auth";

export const fetchUnbundledUserAndBusinessDetails = async () => {
  const utilStore = useUtilsStore();
  const businessStore = useBusinessStore();
  const numberStore = useNumberStore();
  const userStore = useUsersStore();

  try {
    userStore.isFetchingUserDetail = true;

    const [pendingSetupResponse] = await Promise.all([
      getUnprovisionedPayment(),
      handleFetchUserDetails(),
    ]);

    const pendingNumberSetup = pendingSetupResponse.data;

    utilStore.setSetUpPayload(pendingNumberSetup?.data);

    if (utilStore.pendingSetupPayload?.length) {
      await router.push("/provision-number");
      return;
    }

    if (
      // If there is no pending payment and no business, redirect to complete signup
      !businessStore.businesses?.length
    ) {
      await router.push("/complete-signup");
      return;
    }

    const businessId = businessStore.currentBusinessId;

    if (!businessId) {
      throw new Error("Business ID not found");
    }

    // fetch list of numbers under a business
    const [statusResponse, permissionsResponse] = await Promise.all([
      getSubscriptionStatus({ businessId }),
      getPermissions(),
      numberStore.getUserPhonesFromBusiness(),
    ]);

    userStore.permissions = permissionsResponse;
    numberStore.subscriptionStatus = statusResponse.data.data.status;
  } catch (error) {
    handleError({
      error,
      fallbackMessage: "Error fetching user and business details",
      silent: true,
    });
  } finally {
    userStore.isFetchingUserDetail = false;
  }
};
